import script from "./UserCard.vue?vue&type=script&setup=true&lang=js"
export * from "./UserCard.vue?vue&type=script&setup=true&lang=js"

import "./UserCard.vue?vue&type=style&index=0&id=2a93e0e6&lang=postcss&scoped=true"

import exportComponent from "/builds/atlatl-software/atlatl-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2a93e0e6"]])

export default __exports__